import React, { useContext, useState } from "react";
import Input from "./Reusable/Input";
import Button from "./Reusable/Button";
import { ArrowLongRightIcon } from "@heroicons/react/24/outline";
import Vazron_Logo from "../assets/vazron_logo.png";
import toast from "react-hot-toast";
import { UserContext } from "./Context/UserContext";
import GetLocalStorageValue from "./Reusable/GetLocalStorageValue";
import { BaseURL } from "./Reusable/BaseURL";

export default function Login() {
  const { darkTheme, setLoginData } = useContext(UserContext);
  const [isLogin, setIsLogin] = useState("login");
  const [isShowPassword, setIsShowPassword] = useState(false);

  const [username, setUsername] = useState("");
  const [aPassword, setAPassword] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [submitDisable, setSubmitDisable] = useState(false);

  async function loginSubmit(e) {
    e.preventDefault();

    setSubmitDisable(true);
    const formData = new FormData();
    formData.append("username", username);
    formData.append("password", password);

    // const apiUrl = "https://erp.vazron.in/api/login";
    const response = await fetch(`${BaseURL}/login`, {
      method: "POST",
      headers: {
        Accept: "application/json",
        // Authorization: `Bearer ${userToken}`,
        // "access-control-allow-origin" : "*",
        // 'Content-Type': 'application/json',
      },
      body: formData,
      // credentials: "include",
    });

    const resData = await response.json();
    console.log("loginData", resData);
    // console.log("resData", response);

    // LOGIN-DATA
    if (resData?.status === true) {
      toast.success("Successfully logged in");
      localStorage.setItem("vazronLoginData", JSON.stringify(resData.data));

      const localStorageData = GetLocalStorageValue("vazronLoginData", {});
      setLoginData(localStorageData);
      setSubmitDisable(false);
    }
    if (resData.status === false) {
      setSubmitDisable(false);
      if (resData.error?.message?.username) {
        toast.error(resData.error.message.username);
      } else if (resData.error?.message?.password) {
        toast.error(resData.error.message.password);
      } else {
        toast.error(resData.error.message);
      }
    }
  }
  return (
    <div className="flex items-center justify-center h-screen">
      <div className="p-4 m-4 rounded-xl shadow-md bg-slate-50 w-96">
        <div className={"flex items-center justify-center flex-col"}>
          <img src={Vazron_Logo} alt="vazron_logo" className="w-[400px]" />
          <div className="my-4 text-center text-[18px] md:text-[20px] lg:text-[24px]">
            {isLogin === "login" ? "Login" : "Register"}
          </div>
        </div>
        <form>
          {isLogin === "register" && (
            <Input
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              label="Email"
              type="text"
            />
          )}
          <Input
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
            label="Username"
            type="text"
          />

          <Input
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            minLength={6}
            label="Password"
            type={isShowPassword ? "text" : "password"}
            togglePassword={() => setIsShowPassword(!isShowPassword)}
          />

          {isLogin === "register" && (
            <Input
              value={aPassword}
              onChange={(e) => setAPassword(e.target.value)}
              required
              label="Re-Passsword"
              type={isShowPassword ? "text" : "password"}
              togglePassword={() => setIsShowPassword(!isShowPassword)}
            />
          )}

          <Button
            disabled={submitDisable}
            type="submit"
            onClick={(e) => loginSubmit(e)}
            className={
              "my-3 w-full flex items-center justify-center gap-1 !bg-blue-100 hover:!bg-blue-200 active:!bg-gray-500"
            }
          >
            {submitDisable ? (
              "Wait.."
            ) : (
              <ArrowLongRightIcon className="w-6 h-6 text-slate-500" />
            )}
          </Button>
          {/* {isLogin === "login" ? (
          <>
            <div className="text-center text-sm">
              Not a member please{" "}
              <span onClick={() => setIsLogin("register")} className="cursor-pointer transition-all hover:font-[500] text-emerald-500 border-b border-emerald-500 py-[3px]">Register</span>
            </div>
          </>
        ) : (
            <div className="text-center text-sm">
            Already have an account{" "}
            <span onClick={() => setIsLogin("login")} className="cursor-pointer transition-all hover:font-[500] text-emerald-500 border-b border-emerald-500 py-[3px]">Login</span>
          </div>
        )} */}

          <div className="text-center text-sm mt-3 mb-1">
            {/* Not a member please{" "} */}
            <span
              onClick={() => setIsLogin("register")}
              className="text-[14px] cursor-pointer transition-all hover:text-emerald-600 text-emerald-500 border-b border-emerald-500 py-[3px]"
            >
              Forgot Password
            </span>

            {/* <div className="mt-2">
              Captch
              <input type="text" className="border rounded-xl ml-1" />
            </div> */}
          </div>
        </form>
      </div>
    </div>
  );
}
